/**
 * Warranty Information page — accordion, scroll reveal, progress bar.
 * Accordion heights use Pretext (window.__bmwPretext) when available.
 */
(function () {
  var ACCORDION_FONT = '300 14px Inter';
  var ACCORDION_LINE_HEIGHT = 14 * 1.65;
  var ACCORDION_PADDING = 68;

  function measureAccordionHeight(text, maxWidth) {
    if (window.__bmwPretext && window.__bmwPretext.measureBlockHeightCached) {
      return window.__bmwPretext.measureBlockHeightCached(
        text,
        ACCORDION_FONT,
        maxWidth,
        ACCORDION_LINE_HEIGHT
      );
    }
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    if (!ctx) return 120;
    ctx.font = ACCORDION_FONT;
    var words = text.split(' ');
    var line = '';
    var lineCount = 0;
    for (var i = 0; i < words.length; i++) {
      var testLine = line + (line ? ' ' : '') + words[i];
      if (ctx.measureText(testLine).width > maxWidth && line !== '') {
        lineCount++;
        line = words[i];
      } else {
        line = testLine;
      }
    }
    if (line) lineCount++;
    return lineCount * ACCORDION_LINE_HEIGHT;
  }

  function initAccordion(root) {
    var accordion = root.querySelector('#exclusionsAccordion');
    if (!accordion) return;
    var items = accordion.querySelectorAll('.accordion-item');

    items.forEach(function (item) {
      var trigger = item.querySelector('.accordion-trigger');
      var body = item.querySelector('.accordion-body');
      var inner = item.querySelector('.accordion-body-inner');
      if (!trigger || !body || !inner) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');

        items.forEach(function (other) {
          if (other !== item && other.classList.contains('open')) {
            other.classList.remove('open');
            var otherBody = other.querySelector('.accordion-body');
            if (otherBody) {
              otherBody.style.maxHeight = '0px';
              otherBody.style.opacity = '0';
            }
          }
        });

        if (isOpen) {
          item.classList.remove('open');
          body.style.maxHeight = '0px';
          body.style.opacity = '0';
        } else {
          item.classList.remove('open');
          void item.offsetHeight;
          item.classList.add('open');
          var p = inner.querySelector('p');
          var bodyText = p ? p.textContent : '';
          var containerWidth = inner.getBoundingClientRect().width || 600;
          var measuredH = measureAccordionHeight(bodyText, containerWidth);
          body.style.maxHeight = Math.ceil(measuredH) + ACCORDION_PADDING + 'px';
          body.style.opacity = '1';
        }
      });
    });
  }

  function initReveal(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.querySelectorAll('.reveal').forEach(function (el) {
        el.classList.add('visible');
      });
      return;
    }
    var revealEls = root.querySelectorAll('.reveal');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initProgressBar(root) {
    var bar = root.querySelector('[data-warranty-progress]');
    if (!bar) return;
    window.addEventListener(
      'scroll',
      function () {
        var scrollTop = window.scrollY;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        var pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
        bar.style.width = pct + '%';
      },
      { passive: true }
    );
  }

  function initSidebarSpy(root) {
    var nav = root.querySelector('#sidebarNav');
    if (!nav) return;
    var links = nav.querySelectorAll('a[href^="#"]');
    var sections = Array.prototype.slice
      .call(links)
      .map(function (a) {
        return root.querySelector(a.getAttribute('href'));
      })
      .filter(Boolean);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            links.forEach(function (a) {
              a.classList.toggle('active', a.getAttribute('href') === '#' + id);
            });
          }
        });
      },
      { rootMargin: '-60px 0px -50% 0px', threshold: 0 }
    );
    sections.forEach(function (s) {
      observer.observe(s);
    });
  }

  function initHeroReveal(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.querySelectorAll('.hero-band .reveal').forEach(function (el) {
        el.classList.add('visible');
      });
      return;
    }
    var heroReveal = root.querySelectorAll('.hero-band .reveal');
    requestAnimationFrame(function () {
      heroReveal.forEach(function (el, i) {
        setTimeout(function () {
          el.classList.add('visible');
        }, i * 100);
      });
    });
  }

  function initSection(root) {
    initHeroReveal(root);
    initReveal(root);
    initAccordion(root);
    initProgressBar(root);
    initSidebarSpy(root);
  }

  function boot() {
    document.querySelectorAll('[data-section-type="warranty-information"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-section-type="warranty-information"]')) {
      initSection(event.target);
    }
  });
})();
